module.exports = __webpack_public_path__ + "static/media/Pauseicon.04f6f388.svg";